export const headers = {
    DESCRIPTION: "Description",
    FROM: "Introduced",
    TO: "Discontinued",
    SELECTION: "",
}